module.exports = __webpack_public_path__ + "img/9.182e51e2.png";